export enum CounterTypes {
  STANDARD = 'standard',
  EVERGREEN = 'evergreen',
}
